// removed by extract-text-webpack-plugin
module.exports = {"container":"StickyFooterLayout__container___3YSx4","content":"StickyFooterLayout__content___12DdB"};